<p-toast></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
<p-confirmPopup key="itemsnc"></p-confirmPopup>
<p-menu #menuContextuelAjout popup="popup" [model]="contenuMenuContextuelAjout">
    <ng-template pTemplate="item" let-item>
        <div class="flex align-items-center gap-2 p-2 cursor-pointer" (click)="item.command()">
            <i [class]="item.icon + ' mr-2'"></i>
            <div class="flex flex-column">
                <span>{{item.label}}</span>
                <small class="text-500">{{item.description}}</small>
            </div>
        </div>
    </ng-template>
</p-menu>
<p-menu #menuContextuelItem popup="popup" [model]="contenuMenuContextuelItem"></p-menu>
<p-menu #menuContextuelActions popup="popup" [model]="contenuMenuSection"></p-menu>


<p-card *ngIf="!EstCharge()">
    <app-loading [title]="'Chargement de l\'inventaire'" [httpEvent]="loadingEvent"
        [error]="loadingError"></app-loading>
</p-card>

<div class="grid" *ngIf="EstCharge()">
    <div class="col-12">
        <div class="my-4">
            <h5 *ngIf="statutId == 901" class="my-1">Unités</h5>
            <h5 *ngIf="statutId == null" class="my-1">Items</h5>
            <h5 *ngIf="statutId == 902" class="my-1">Pièces</h5>
            <h5 *ngIf="statutId == 15" class="my-1">Incomplets</h5>
            <h5 *ngIf="statutId == 2" class="my-1">Archive</h5>
            <span *ngIf="statutId == null" class="text-500">Les items sont les objets d'inventaire. Vous pouvez les
                assigner à un entite, associer des pièces et des documents, etc.</span>
            <span *ngIf="statutId == 901" class="text-500">Les unités sont les objets d'inventaire qui sont surtout
                utiles au département mécanique. Vous pouvez créer des bons de travail à partir de ceux-ci</span>
            <span *ngIf="statutId == 902" class="text-500">Les pièces sont les objets d'inventaire qui sont utiles au
                département mécanique. Vous pouvez les associer à des unités.</span>
            <span *ngIf="statutId == 15" class="text-500">Les incomplets sont les objets d'inventaire qui ont des
                propriétés obligatoires non remplies.</span>
            <span *ngIf="statutId == 2" class="text-500">Items d'inventaire qui ne sont plus utilisés.</span>
        </div>
        <div class="flex align-items-center flex-wrap justify-content-between my-2">
            <div class="flex align-items-center gap-2 flex-wrap">
                <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input autofocus pInputText type="text" [(ngModel)]="globalFilter"
                        (input)="dt.filterGlobal($event.target.value, 'contains')" (keyup.enter)="surEntreeRecherche()"
                        placeholder="Recherche..." />
                </span>
                <button *ngIf="estAutorise('item_creer')" pButton pRipple icon="pi pi-plus" class="p-button-success"
                    label="Ajouter" (click)="surBoutonAjout($event)"></button>

                <button pButton pRipple icon="pi pi-sliders-h" class="p-button-outlined" pTooltip="Filtres avancés"
                    (click)="afficherFiltresAvances = !afficherFiltresAvances" tooltipPosition="bottom">
                </button>

                <button pButton class="p-button-outlined" icon="pi pi-filter-slash" pTooltip="Réinitialiser les filtres"
                    tooltipPosition="bottom" (click)="clearFilters(dt)"></button>

                <p-button *ngIf="selectedItems && selectedItems.length > 0" label="Actions multiples" icon="pi pi-cog"
                    (click)="surMenuContextuelActions($event)">
                </p-button>
            </div>

            <div class="flex align-items-center gap-4">
                <app-selecteur-colonnes [colonnesDisponibles]="colonnesDisponibles" [(ngModel)]="selectedColumns"
                    (onReset)="reinitialiserColonnesSelectionnees()">
                </app-selecteur-colonnes>
            </div>
        </div>
        <p-table #dt [value]="items?.value() ?? []" [columns]="selectedColumns" dataKey="itemId" autoLayout="true"
            tableStyleClass="tableNormale" [totalRecords]="items?.value()?.length" [rowHover]="true"
            [sortField]="tableParams.getValue().sortField ?? 'numero'"
            [sortOrder]="tableParams.getValue().sortOrder ?? 1" [rows]="100" [paginator]="true"
            [rowsPerPageOptions]="[10,25,50,100,500]" [loading]="items == null"
            [globalFilterFields]="['numero','description','statut','categorie','sousCategorie','marque','modele','noSerie','noPlaque','produitsFournisseurChaine','ancienNumero','noTag','assignation','emplacement.code']"
            showCurrentPageReport currentPageReportTemplate="Page: {currentPage} / {totalPages} ({totalRecords} items)"
            [(selection)]="selectedItems" [filterDelay]="0" [exportHeader]="'customExportHeader'" [scrollable]="true"
            (onFilter)="tableParams.setValue(dt)" (onSort)="tableParams.setValue(dt)"
            (onPage)="tableParams.setValue(dt)">
            <ng-template pTemplate="header" let-columns>
                <tr>
                    <th style="width: 3rem">
                        <p-tableHeaderCheckbox pTooltip="Faire attention de ne pas sélectionner plus de 8000 items" />
                    </th>
                    <th>
                    </th>
                    <th pSortableColumn="numero">
                        <div class="flex justify-content-between align-items-center">
                            Numéro
                            <p-sortIcon field="numero"></p-sortIcon>
                            <p-columnFilter type="text" field="numero" display="menu" class="ml-auto">
                            </p-columnFilter>
                        </div>
                    </th>
                    <th pSortableColumn="description">
                        <div class="flex justify-content-between align-items-center">
                            Description
                            <p-sortIcon field="description"></p-sortIcon>
                            <p-columnFilter type="text" field="description" display="menu" class="ml-auto">
                            </p-columnFilter>
                        </div>
                    </th>
                    <th>
                        <div class="flex justify-content-between align-items-center">
                            Statut
                            <p-columnFilter field="statut" matchMode="in" display="menu" [showMatchModes]="false"
                                [showOperator]="false" [showAddButton]="false">
                                <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                    <p-multiSelect [ngModel]="value" [options]="statuts" placeholder="Any"
                                        (onChange)="filter($event.value)" optionLabel="name">
                                        <ng-template let-option pTemplate="item">
                                            <div class="multiselect-representative-option">

                                                <span class="ml-1">{{option.nom}}</span>
                                            </div>
                                        </ng-template>
                                    </p-multiSelect>
                                </ng-template>
                            </p-columnFilter>
                        </div>
                    </th>
                    <th *ngIf="EstColonneSelectionnee('categorie')" pSortableColumn="categorie.nom">
                        <div class="flex justify-content-between align-items-center">
                            Catégorie
                            <p-sortIcon field="categorie.nom"></p-sortIcon>
                            <p-columnFilter field="categorie.categorieId" matchMode="in" display="menu"
                                [showMatchModes]="false" [showOperator]="false" [showAddButton]="false">
                                <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                    <p-multiSelect [ngModel]="value" [options]="listeCategories" placeholder="Any"
                                        (onChange)="onChangeCategorie($event.value, filter)" optionLabel="nom"
                                        optionValue="categorieId" dataKey="categorieId">
                                        <ng-template let-option pTemplate="item">
                                            <div class="multiselect-representative-option">
                                                <span class="ml-1">{{option.nom}}</span>
                                            </div>
                                        </ng-template>
                                    </p-multiSelect>
                                </ng-template>
                            </p-columnFilter>
                        </div>
                    </th>
                    <th *ngIf="EstColonneSelectionnee('sousCategorie')" pSortableColumn="sousCategorie.nom">
                        <div class="flex justify-content-between align-items-center">
                            Sous-catégorie
                            <p-sortIcon field="sousCategorie.nom"></p-sortIcon>
                            <p-columnFilter field="sousCategorie.nom" matchMode="in" display="menu"
                                [showMatchModes]="false" [showOperator]="false" [showAddButton]="false">
                                <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                    <p-multiSelect [ngModel]="value" [options]="filtreSousCategories" placeholder="Any"
                                        (onChange)="filter($event.value)" optionLabel="">
                                        <ng-template let-option pTemplate="item">
                                            <div class="multiselect-representative-option">
                                                <span class="ml-1">{{option}}</span>
                                            </div>
                                        </ng-template>
                                    </p-multiSelect>
                                </ng-template>
                            </p-columnFilter>
                        </div>
                    </th>
                    <th *ngIf="EstColonneSelectionnee('marque')" pSortableColumn="marque">
                        <div class="flex justify-content-between align-items-center">
                            Marque
                            <p-sortIcon field="marque"></p-sortIcon>
                            <p-columnFilter type="text" field="marque" display="menu" class="ml-auto">
                            </p-columnFilter>
                        </div>
                    </th>
                    <th *ngIf="EstColonneSelectionnee('modele')" pSortableColumn="modele">
                        <div class="flex justify-content-between align-items-center">
                            Modèle
                            <p-sortIcon field="modele"></p-sortIcon>
                            <p-columnFilter type="text" field="modele" display="menu" class="ml-auto">
                            </p-columnFilter>
                        </div>
                    </th>
                    <th *ngIf="EstColonneSelectionnee('noProduit')">
                        <div class="flex justify-content-between align-items-center">
                            No pièce fournisseur
                        </div>
                    </th>
                    <th *ngIf="EstColonneSelectionnee('noCtrl')" pSortableColumn="noCtrl">
                        <div class="flex justify-content-between align-items-center">
                            No Ctrl
                            <p-sortIcon field="noCtrl"></p-sortIcon>
                            <p-columnFilter type="text" field="noCtrl" display="menu" class="ml-auto">
                            </p-columnFilter>
                        </div>
                    </th>
                    <th *ngIf="EstColonneSelectionnee('assignation')" pSortableColumn="assignation">
                        <div class="flex justify-content-between align-items-center">
                            Assigné à
                            <p-sortIcon field="assignation"></p-sortIcon>
                            <p-columnFilter field="assignation" matchMode="assignationContains" display="menu"
                                [showMatchModes]="false" [showOperator]="false" [showAddButton]="false">
                                <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                    <app-assignation-filter [(ngModel)]="selectionAssignations"
                                        (onChange)="filter($event)">
                                    </app-assignation-filter>
                                </ng-template>
                            </p-columnFilter>
                        </div>
                    </th>
                    <th *ngIf="EstColonneSelectionnee('compagnie')" pSortableColumn="compagnie.nom">
                        <div class="flex justify-content-between align-items-center">
                            Compagnie
                            <p-sortIcon field="compagnie.nom"></p-sortIcon>
                            <p-columnFilter field="compagnie.nom" matchMode="in" display="menu" [showMatchModes]="false"
                                [showOperator]="false" [showAddButton]="false">
                                <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                                    <p-multiSelect [ngModel]="value" [options]="filtreCompagnies" placeholder="Any"
                                        (onChange)="filter($event.value)" optionLabel="name">
                                        <ng-template let-option pTemplate="item">
                                            <div class="multiselect-representative-option">
                                                <span class="ml-1">{{option}}</span>
                                            </div>
                                        </ng-template>
                                    </p-multiSelect>
                                </ng-template>
                            </p-columnFilter>
                        </div>
                    </th>
                    <ng-container *ngFor="let col of colonnesSelectionnees">
                        <th *ngIf="!col.base" [pSortableColumn]="col.champ">
                            <div class="flex justify-content-between align-items-center">
                                {{col.entete}}
                                <p-sortIcon [field]="col.champ"></p-sortIcon>
                                <p-columnFilter [type]="obtenirTypeChamp(col.type)" [field]="col.champ" display="menu"
                                    class="ml-auto">
                                </p-columnFilter>
                            </div>
                        </th>
                    </ng-container>
                    <th class="text-right" alignFrozen="right" pFrozenColumn>Actions</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-item let-columns="columns">
                <tr [pContextMenuRow]="item" [pSelectableRow]="item"
                    (contextmenu)="surMenuContextuelItem($event, item)">
                    <td>
                        <p-tableCheckbox [value]="item"></p-tableCheckbox>
                    </td>
                    <td class="p-0">
                        <div *ngIf="item.photoId">
                            @defer (on viewport) {
                            <app-image-loader [documentId]="item.photoId" [width]="40" [height]="40"
                                [title]="item.numero"></app-image-loader>
                            }
                            @placeholder {
                            <div class="flex align-items-center justify-content-center"
                                style="height: 40px; width: 40px;">
                                <p-skeleton width="40px" height="40px"></p-skeleton>
                            </div>
                            }
                        </div>
                    </td>
                    <td>
                        <div class="flex align-items-center gap-2">
                            <a *ngIf="estAutorise('item_detail')" [routerLink]="'/item/' + item.itemId"
                                class="text-primary hover:underline">{{item.numero}}</a>
                            <span *ngIf="!estAutorise('item_detail')">{{item.numero}}</span>
                        </div>
                    </td>
                    <td>
                        <i *ngIf="item.produitDangereux" class="pi pi-exclamation-triangle text-yellow-500 mr-2"
                            pTooltip="Produit Dangereux"></i>
                        {{item.description}}
                    </td>
                    <td><span [class]="'statut ' + item.statut.nom.toLowerCase()">
                            {{item.statut.nom}}
                        </span>
                    </td>
                    <td *ngIf="EstColonneSelectionnee('categorie')">
                        {{item.categorie.nom}}
                    </td>
                    <td *ngIf="EstColonneSelectionnee('sousCategorie')">
                        {{item.sousCategorie?.nom}}
                    </td>
                    <td *ngIf="EstColonneSelectionnee('marque')">
                        {{item.marque}}
                    </td>
                    <td *ngIf="EstColonneSelectionnee('modele')">
                        {{item.modele}}
                    </td>
                    <td *ngIf="EstColonneSelectionnee('noProduit')" style="white-space: pre-line;">
                        {{item.produitsFournisseurChaine}}
                    </td>
                    <td *ngIf="EstColonneSelectionnee('noCtrl')">
                        {{item.noCtrl}}
                    </td>
                    <td *ngIf="EstColonneSelectionnee('assignation')">
                        <app-employe-avec-emplacement *ngIf="item.employe"
                            [employe]="item.employe"></app-employe-avec-emplacement>
                        <span *ngIf="item.emplacement && !item.employe" class="flex align-items-center gap-1">
                            <i class="pi pi-map-marker"></i> {{item.emplacement.nom}}
                        </span>
                    </td>
                    <td *ngIf="EstColonneSelectionnee('compagnie')">
                        <app-compagnie-label [compagnie]="item.compagnie"></app-compagnie-label>
                    </td>
                    <ng-container *ngFor="let col of colonnesSelectionnees">
                        <td *ngIf="col.type == ETypeChampAttribut.Texte">
                            {{item[col.champ]}}
                        </td>
                        <td *ngIf="col.type == ETypeChampAttribut.Numerique">
                            {{item[col.champ] | number:'1.0-0'}}
                        </td>
                        <td *ngIf="col.type == ETypeChampAttribut.Decimales">
                            {{item[col.champ] | number:'1.2-2'}}
                        </td>
                        <td *ngIf="col.type == ETypeChampAttribut.Date">
                            {{item[col.champ] | date:'yyyy/MM/dd'}}
                        </td>
                        <td *ngIf="col.type == ETypeChampAttribut.Booleen">
                            {{item[col.champ] ? 'Oui' : 'Non'}}
                        </td>
                    </ng-container>
                    <td alignFrozen="right" pFrozenColumn>
                        <p-buttongroup>
                            <p-button *ngIf="estAutorise('item_detail')" icon="pi pi-eye" severity="success"
                                size="small" (click)="OuvrirDetailItem(item.itemId)" pTooltip="Voir l'item"
                                pTooltipPosition="top"></p-button>
                            <p-button *ngIf="estAutorise('item_detail')" icon="pi pi-external-link" severity="secondary"
                                size="small" (click)="OuvrirDetailItemNouvelOnglet(item.itemId)"
                                pTooltip="Aperçu de l'item" pTooltipPosition="top"></p-button>
                            <p-button *ngIf="estAutorise('item_creer')" icon="pi pi-bars" severity="secondary"
                                size="small" (click)="surMenuContextuelItem($event, item)"></p-button>
                        </p-buttongroup>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="12" class="text-center">
                        <div class="flex flex-column align-items-center gap-2 m-4">
                            <i class="pi pi-id-card opacity-60 mb-1" style="font-size: 2rem;"></i>
                            <div class="text-lg font-medium">Aucun item trouvé</div>
                            <div class="text-500">Modifiez vos critères de recherche pour trouver des items</div>
                        </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>


</div>



<p-dialog [(visible)]="dialogueNouvelItem" [style]="{width: '85%'}" header="Nouvel item" [modal]="true"
    styleClass="fluid formgrid grid">
    <ng-template pTemplate="content">

        <app-ajout-item [(item)]="nouvelItem" [submitted]="submitted"></app-ajout-item>

    </ng-template>

    <ng-template pTemplate="footer">

        <button pButton pRipple label="Créer" icon="pi pi-save" class="p-button-primary"
            (click)="creerNouvelItem()"></button>
        <button pButton pRipple label="Annuler" icon="pi pi-ban" class="p-button-text"
            (click)="annulerNouvelItem()"></button>
    </ng-template>
</p-dialog>
<p-sidebar [(visible)]="afficherDetailItem" [style]="{width:'95%'}" position="left">
    <app-detail-item [itemId]="detailItemId" *ngIf="afficherDetailItem"></app-detail-item>
</p-sidebar>

<p-sidebar [(visible)]="afficherFiltresAvances" [style]="{width:'30em'}" position="right" [blockScroll]="true">
    <ng-template pTemplate="header">
        <h3>Filtres avancés</h3>
    </ng-template>

    <app-filtres-avances [(filtres)]="filtres" [filterConfigs]="filterConfigs"
        [table]="tableItems"></app-filtres-avances>

    <ng-template pTemplate="footer">
        <div class="flex justify-content-end gap-2">
            <p-button label="Réinitialiser" icon="pi pi-refresh" [loading]="loadingNouvelItem"
                (onClick)="reinitialiserFiltres()" styleClass="p-button-outlined"></p-button>
            <p-button label="Fermer" icon="pi pi-times" (onClick)="afficherFiltresAvances = false"></p-button>
        </div>
    </ng-template>
</p-sidebar>